import {PageSlot} from "mfront";

export default function PrivateLayout() {
    return (
        <>
            Private Layout
            <div>
                <PageSlot/>
            </div>
        </>
    )
}